import jQuery from "jquery";
import {
  customerVoiceSwiper,
  touchExampleSwiper,
  spTouchExampleSwiper,
  spCartoonExampleSwiper,
  partnersSwiper,
} from "../javascript/vendor/swiper";
window.$ = window.jQuery = jQuery;
// jQuery の $.ajax に CSRF トークンを自動付与（@rails/ujs は付けないため）
import "../javascript/csrf_ajax_prefilter";
import * as Fontawesome from "../javascript/vendor/fontawesome";
import * as Dropify from "../javascript/vendor/dropify";
// import "rails-ujs";

require("bootstrap");
require("../javascript/vendor/lightbox");
import "@mdi/font/css/materialdesignicons.css"; // MDI アイコン（#33: users/public 系ビューも mdi を使う）
require("../styles/frontpage/entry.scss");
require("../javascript/module/preorder");

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);

$(function () {
  customerVoiceSwiper();
  touchExampleSwiper();
  spTouchExampleSwiper();
  spCartoonExampleSwiper();
  partnersSwiper();

  Fontawesome.iconToSvg();

  Dropify.activate({
    messages: {
      default:
        '<p class="dropify-text">ここに写真をドロップ<br>または</p><p class="btn-dropify">写真を選択<p>',
      replace: '<p class="dropify-text">ここに写真をドロップ<br>または</p>',
      remove: "削除",
      error: "Error",
    },
  });

  // Handle remote links
  // $(document).on("click", 'a[data-remote="true"]', async (e) => {
  //   e.preventDefault();
  //   const $this = $(e.currentTarget);

  //   try {
  //     await $.ajax({
  //       url: $this.attr("href"),
  //       type: "GET",
  //     });
  //   } catch (error) {
  //     console.error("Ajax request failed:", error);
  //     toastr.error("リクエストに失敗しました");
  //   }
  // });
});

// Toastrの設定
import toastr from "toastr";
toastr.options = {
  closeButton: true,
  timeout: 2000,
  preventDuplicates: true,
  // dashboard.js と同じ理由（Codex 指摘）。既定の escapeHtml: false だと
  // flash の内容が HTML として解釈される。
  escapeHtml: true,
};
global.toastr = toastr;
